import { AbstractControl } from '@angular/forms';
import { FormlyField, FormlyFieldConfig, FormlyTemplateOptions } from '@ngx-formly/core';

export interface FormSection {
  id: number;
  label: string;
  order: number;
  fields: FormField[];
}
export interface FormField {
  key: string;
  name: string;
  type: FormlyField;
  templateOptions: FormlyTemplateOptions;
  template?: string;
  className: string;
  defaultValue?: any;
  hide?: boolean;
  hideExpression?: boolean | string | object;
  expressionProperties?: boolean | string | object;
  formControl: AbstractControl;
  validation?: object;
  validators?: any;
  section?: FormSection;
  order: number;
  fieldGroup: FormlyFieldConfig[];
}

export enum FormFieldType {
  text = 'text',
  textarea = 'textarea',
  select = 'select',
  checkbox = 'checkbox',
  radio = 'radio',
  date = 'date',
  time = 'time',
  datetime = 'datetime',
  datetimeLocal = 'datetime-local',
  number = 'number',
  range = 'range',
  color = 'color',
  file = 'file',
  hidden = 'hidden',
  image = 'image',
  button = 'button',
  submit = 'submit',
  reset = 'reset',
  search = 'search',
  tel = 'tel',
  email = 'email',
  url = 'url',
  password = 'password',
}

export enum formValuePicker {
  inquirerCountry = 'inquirerCountry',
  inquirerRole = 'inquirerRole',
  businessUnit = 'businessUnit',
  caseCategory = 'caseCategory',
  caseSubCategory = 'caseSubCategory',
  city = 'city',
  cityAssistance = 'cityAssistance',
  contactType = 'contactType',
  country = 'country',
  countryAssistance = 'countryAssistance',
  contactMethod = 'contactMethod',
  contactMethodAssistance = 'contactMethodAssistance',
  contactLanguage = 'contactLanguage',
  contactLanguageAssistance = 'contactLanguageAssistance',
  contactRoleAssistance = 'contactRoleAssistance',
  shipmentIdentifierValues = 'shipmentIdentifierValues',
  shipmentIdentifierOptions = 'shipmentIdentifier',
  postalCode = 'postalCode',
  postalCodeAssistance = 'postalCodeAssistance',
  priority = 'priority',
  premierShipment ='premierShipment',
  premierShipmentNotes ='premierShipmentNotes',
  state = 'state',
  stateAssistance = 'stateAssistance',
  street = 'street',
  streetAssistance = 'streetAssistance',  
}

export enum shipmentIdentifier {
  confirmationNumber = 'Confirmation Number',
  infoNoticeNumber = 'InfoNotice Number',
  shipmentId = 'Shipment ID',
  pickupRecordNumber = 'Pickup Record Number',
  proNumber = 'Pro Number',
  trackingNumber = 'Tracking Number',
  purchaseOrderNumber = 'Purchase Order Number',
  referenceNumber = 'Reference Number',
  invoiceNumber = 'Invoice Number',
  billOfLading = 'Bill of Lading',
  claimNumber = 'Claim Number',
  packageReferenceNumber = 'Package Reference Number',
  mailInnovations = 'Mail Innovations',
}
